module.exports = "/images/ready-made-professional-timesheets@3x.png?f7882d6890b6a5b5cdb2a3dca3503345";